<template>
  <div class="tag">
    {{ content }}
  </div>
</template>

<script>
export default {
  name: 'tag',
  data: function () {
    return {

    }
  },
  props: {
    content: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
  },
  created () {
  },
  destroyed () {
  },
  methods: {
  }
}
</script>
